import SearchIcon from "@mui/icons-material/Search";
import { Box, Grid, InputAdornment, TextField, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { bookingHeaderStyles } from "styles/BookingReferralDirectory/bookingsHeader.styles";
import { BookingsAndReferralsTab } from "./types";

interface BookingHeaderProps {
  activeTab: string;
  setActiveTab: (option: string) => void;
  businessUser: Boolean | undefined;
  searchQuery: string;
  setSearchQuery: (query: string) => void;
}

const BookingsHeader: React.FC<BookingHeaderProps> = ({
  activeTab,
  setActiveTab,
  businessUser,
  searchQuery,
  setSearchQuery,
}) => {
   const navigate = useNavigate();
  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(event.target.value);
  };

  return (
    <>
      {/* Top Header */}
      <Grid container sx={bookingHeaderStyles.bookingHeader}>
        {/* Left Box */}
        <Grid item xs={12} sm={4} sx={bookingHeaderStyles.headerLeftContainer}>
          <Typography fontSize="17px" fontWeight="600" color="#282828" sx={{ display: "flex", alignItems: "center" }} ></Typography>
        </Grid>

        {/* Middle Toggle Tabs */}
        <Grid item xs={12} sm={4} sx={bookingHeaderStyles.headerMidContainer}>
          {businessUser && (
            <Box sx={bookingHeaderStyles.toggleContainer}>
              <Box
                sx={bookingHeaderStyles.bookingToggle(
                  activeTab,
                  BookingsAndReferralsTab.Bookings
                )}
                onClick={() => setActiveTab(BookingsAndReferralsTab.Bookings)}
              >
                <Typography
                  sx={bookingHeaderStyles.toggleHeading(
                    activeTab,
                    BookingsAndReferralsTab.Bookings
                  )}
                >
                  Bookings
                </Typography>
              </Box>
              <Box
                sx={bookingHeaderStyles.refferalToggle(
                  activeTab,
                  BookingsAndReferralsTab.Referrals
                )}
                onClick={() => setActiveTab(BookingsAndReferralsTab.Referrals)}
              >
                <Typography
                  sx={bookingHeaderStyles.toggleHeading(
                    activeTab,
                    BookingsAndReferralsTab.Referrals
                  )}
                >
                  Referrals
                </Typography>
              </Box>
            </Box>
          )}
        </Grid>
      </Grid>

      {/* Sub-header */}
      <Grid container sx={bookingHeaderStyles.bookingHeader}>
        <Grid item xs={12} sm={4} sx={bookingHeaderStyles.headerLeftContainer}>
          <Typography sx={bookingHeaderStyles.headerMainText}>
            {activeTab === BookingsAndReferralsTab.Bookings ? "Bookings" : "Referrals"}
          </Typography>
        </Grid>

        <Grid
          item
          xs={12}
          sm={8}
          sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}
        >
          <TextField
            variant="outlined"
            size="small"
            placeholder="Search"
            value={searchQuery}
            onChange={handleSearchChange}
            sx={{
              width: "282px",
              backgroundColor: "#7676801f",
              borderRadius: "10px",
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  border: "none",
                },
                "&:hover fieldset": {
                  border: "none",
                },
                "&.Mui-focused fieldset": {
                  border: "none",
                },
              },
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default BookingsHeader;